module.exports = __webpack_public_path__ + "img/202.81333fe8.jpg";